export default "__VITE_ASSET__DUDwcoLY__"